import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

import { FiltersOptionsByKey, FiltersValuesByKey } from '@ihme/common/types';
import withQueryParams, {
    WithQueryParamsInjectedProps,
} from '@ihme/common/utility/hoc/with-query-params';
import { withStorage, WithStorageProps } from '@ihme/common/packages/storage';
import { ChartProvider } from '@ihme/common/web/components';

import api from '../../api';
import config from '../../config';

import TrendsChartFilters from './TrendsChartFilters';
import TrendsChart from './TrendsChart';

const DEFAULT_FILTERS = {
    age_group_id: config.defaultTrendsAgeGroupId,
    location_id: config.defaultTrendsLocationId,
    metric_id: config.defaultTrendsMetricId,
    measure_id: config.defaultTrendsMeasureId,
    cause_id: config.defaultTrendsCauseId,
};

type Filters = typeof DEFAULT_FILTERS;

type Props = WithStorageProps & WithQueryParamsInjectedProps<Filters> & RouteComponentProps;

type State = {
    refinedGranularity: FiltersOptionsByKey;
    filters: FiltersValuesByKey;
};

class TrendsChartSection extends React.Component<Props, State> {
    state: State = {
        refinedGranularity: {},
        filters: {},
    };

    onFiltersChange = (prevFilters: FiltersValuesByKey, filters: FiltersValuesByKey) => {
        this.setState({ filters });

        const { age_group_id, cause_id } = filters;

        if (prevFilters.cause_id !== cause_id) {
            api.data.getCauseOutcomeFilters({ cause_id })
                .then(refinedGranularity => {
                    this.setState({ refinedGranularity });
                })
                .catch(console.log);
        }

        if (prevFilters.age_group_id !== age_group_id) {
            api.data.getCauseOutcomeFilters({ cause_id, age_group_id })
                .then(({metric_id}) => {
                    this.setState(state => ({
                        refinedGranularity: {
                            ...state.refinedGranularity,
                            metric_id,
                        },
                    }));
                })
                .catch(console.log);
        }
    };

    render() {
        const { location, history, queryParams, cached } = this.props;
        const { refinedGranularity } = this.state;

        return (
            <ChartProvider
                loadFilters={cached(api.data.getCauseOutcomeFilters)}
                loadData={api.data.getCauseOutcomeRecords}
                onFiltersChange={this.onFiltersChange}
                onDataChange={(filters, setFilters) => {
                    const currentMeasureId = this.state.filters
                        ? this.state.filters.measure_id
                        : null;
                    const newMeasureId = filters.measure_id;
                    if (newMeasureId === currentMeasureId) {
                        return null;
                    }
                    if (newMeasureId === config.maternalMortalityRatioMeasureId.toString()) {
                        setFilters(
                            {
                                cause_id: config.allCausesId.toString(),
                                age_group_id: config.tenToFiftyFourAgeGroupId.toString(),
                                metric_id: config.rateMetricId.toString(),
                            },
                            true
                        );
                    }
                }}
                defaultFilters={DEFAULT_FILTERS}
                initialFilters={queryParams}
                history={history}
                location={location}
            >
                <TrendsChartFilters refinedGranularity={refinedGranularity} />
                <TrendsChart />
            </ChartProvider>
        );
    }
}

export default withStorage(withQueryParams(withRouter(TrendsChartSection)));
